import { render, staticRenderFns } from "./sign-up.vue?vue&type=template&id=432f5de6"
import script from "./sign-up.vue?vue&type=script&lang=js"
export * from "./sign-up.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/Resourced/Resourced/Frontend-old/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('432f5de6')) {
      api.createRecord('432f5de6', component.options)
    } else {
      api.reload('432f5de6', component.options)
    }
    module.hot.accept("./sign-up.vue?vue&type=template&id=432f5de6", function () {
      api.rerender('432f5de6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/pages/account/sign-up.vue"
export default component.exports